import './Dice.scss';

export default function Dice({ alt = 'Roll the dice' }: {alt?: string}) {
  return <>
    <img className='DiceIcon' src='/dice-icon.png' alt={alt} />
  </>;
}
